<template>
  <div ref="editor" @mousedown.stop></div>
</template>

<script>
import Quill from 'quill';
import Delta from 'quill-delta';
import fb from '@/firebaseConfig';
//import MagicUrl from 'quill-magic-url';
import debounce from 'lodash/debounce';
//Quill.register('modules/magicUrl', MagicUrl);
import { diff3Merge, diff3MergeIndices } from 'node-diff3';


export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          html: ''
        };
      }
    },
    updatedOn: {},
    emitText: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    allowEnter: {
      type: Boolean,
      default: false
    },
    allowFormats: {
      type: Boolean,
      default: false
    },
    allowMarkdown: {
      type: Boolean,
      default: false
    },
    allowEnterMoveText: {
      type: Boolean,
      default: false
    },
    allowTraversal: {
      type: Boolean,
      default: false
    },
    preventDefaultCtrl: {
      type: Boolean,
      default: false
    },
    hijackUndo: {
      type: Boolean,
      default: false
    },
    hijackCopy: {
      type: Boolean,
      default: false
    },
    hijackPaste: {
      type: Boolean,
      default: false
    },
    enableMagicUrl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editor: null,
      lastUpdated: null,
      previousVal: null
    };
  },
  computed: {
    htmlVal() {
      return this.value.html;
    }
  },
  watch: {
    htmlVal(newVal, oldObjVal) {
      const oldDate = this.lastUpdated;
      const newDate = this.value.updatedOn
        ? this.value.updatedOn.toDate()
        : fb.util.timestamp.now().toDate();
      const originalVal = this.emitText ? this.editor.getText() : this.editor.root.innerHTML;

      let curPos;
      let adjust = 0;
      this.lastUpdated = newDate;
      let val = newVal;
      let setType = 'silent';
      //  check if incoming value is different then current
      if (val != originalVal && val !== this.previousVal) {
        //  check if current value is different then previousVal (did we type something unsaved?)
        if (originalVal != this.previousVal && newDate < oldDate) {
          //  Figure out what we have added.
          const mergedData = diff3Merge(val, this.previousVal, originalVal, true);

          console.log('new String', mergedData);
          let mergedArray = [];
          mergedData.forEach(item => {
            console.log('item', item);
            if ('ok' in item) {
              const { ok } = item;
              console.log('ok', ok);
              ok.forEach(letter => mergedArray.push(letter));
            } else if ('conflict' in item) {
              const { b } = item.conflict;
              console.log('conflict b', b);
              b.split('').forEach(letter => mergedArray.push(letter));
            }
          });
          console.log('mergedArray', mergedArray);
          const mergedString = mergedArray.join('');
          console.log('merged string', mergedString);
          val = mergedString;
          setType = 'user';
        } else if (newDate < oldDate) {
          console.log('tried to overwrite newer changes');
          return false;
        }
        const delta = this.editor.clipboard.convert(val);
        if (this.editor.hasFocus()) {
          console.log('has focus!');
          //  figure out if we need to move the cursor
          curPos = this.editor.getSelection().index;
          const originalPreCursorContent = originalVal.slice(0, curPos);
          const originalPostCursorContent = originalVal.slice(curPos, originalVal.length);
          //  check if pre-cursor content changed
          adjust = 0;
          if (
            val.indexOf(originalPreCursorContent) > 0 ||
            val.indexOf(originalPreCursorContent) == -1
          ) {
            //  it's changed, need to figure out by how much
            //  get the
            if (val.indexOf(originalPostCursorContent > 0)) {
              console.log(val.split(originalPostCursorContent));
              const newPreCursorContent = val.split(originalPostCursorContent)
                ? val.split(originalPostCursorContent)[0]
                : '';
              adjust = newPreCursorContent.length - originalPreCursorContent.length;
            }
          }
        }
        this.editor.setContents(delta, setType);
        this.previousVal = val;
        if (curPos) {
          console.log(curPos, adjust);
          this.editor.setSelection(curPos + adjust);
        }
      }
    },
    disabled(status) {
      this.editor.enable(!status);
    },
    placeholder(v) {
      this.editor.root.setAttribute('data-placeholder', v);
    }
  },
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      formats: this.allowFormats ? this.formats : [],
      placeholder: this.placeholder,
      modules: {
        toolbar: false,
        history: false,
        //magicUrl: this.enableMagicUrl,
        keyboard: {
          bindings: {
            ctrlEnter: {
              key: 13,
              ctrlKey: true,
              handler: () => {
                this.$emit('keyCtrlEnter');
              }
            },
            enter: {
              key: 13,
              handler: (range, context) => {
                if (this.allowEnter) {
                  return true;
                }
                if (this.allowEnterMoveText) {
                  const enterPoint = context.offset;
                  const remaining = this.editor.getLength() - enterPoint;
                  const delta = remaining ? this.editor.getContents(enterPoint) : false;
                  this.$emit('keyEnter', delta);
                  if (remaining) {
                    //  we hit enter in the middle of a line, delete the rest of the line, we will move it to the next
                    this.editor.updateContents(new Delta().retain(enterPoint).delete(remaining));
                  }
                } else {
                  this.$emit('keyEnter');
                }
              }
            },
            escape: {
              key: 27,
              handler: () => {
                this.editor.setSelection(0);
                this.$emit('keyEsc');
              }
            },
            // tab: {
            //   key: 9,
            //   shiftKey: false,
            //   handler: () => {
            //     return true;
            //     // this.$emit('keyTab');
            //     // return false;
            //   }
            // },
            // shiftTab: {
            //   key: 9,
            //   shiftKey: true,
            //   handler: () => {
            //     return true;
            //     // this.$emit('keyShiftTab');
            //     // return false;
            //   }
            // },
            ctrlRight: {
              key: 39,
              ctrlKey: true,
              handler: () => {
                this.$emit('keyCtrlRight');
                if (!this.preventDefaultCtrl) {
                  return true;
                }
              }
            },
            ctrlLeft: {
              key: 37,
              ctrlKey: true,
              handler: () => {
                this.$emit('keyCtrlLeft');
                if (!this.preventDefaultCtrl) {
                  return true;
                }
              }
            },
            arrowLeft: {
              key: 37,
              ctrlKey: false,
              offset: 0,
              handler: () => {
                this.$emit('keyLeftFirstChar');
              }
            },
            arrowRight: {
              key: 39,
              ctrlKey: false,
              suffix: /^$/,
              handler: () => {
                this.$emit('keyRightLastChar');
              }
            },
            arrowDown: {
              key: 40,
              handler: (range, context) => {
                if (this.allowTraversal) {
                  const bounds = this.editor.getBounds(range.index);
                  const isLastLine = this.$refs.editor.offsetHeight - bounds.bottom < 10;
                  if (isLastLine) {
                    const args = { context, range, bounds };
                    this.$emit('keyDownLastLine', args);
                    return false;
                  } else {
                    return true;
                  }
                } else {
                  return true;
                }
              }
            },
            arrowUp: {
              key: 38,
              handler: (range, context) => {
                if (this.allowTraversal) {
                  const bounds = this.editor.getBounds(range.index);
                  // console.log(bounds);
                  const isFirstLine = bounds.top < 10;
                  if (isFirstLine) {
                    const args = { context, range, bounds };
                    this.$emit('keyUpFirstLine', args);
                    return false;
                  } else {
                    return true;
                  }
                } else {
                  return true;
                }
              }
            },
            backspace: {
              key: 8,
              handler: range => {
                if (range.index == 0 && this.editor.getLength() == 1) {
                  this.$emit('keyBackspaceEmpty');
                  return false;
                } else if (range.index == 0 && range.length == 0) {
                  const delta = this.editor.getLength() > 1 ? this.editor.getContents() : false;
                  this.$emit('keyBackspaceFirstChar', delta);
                  return false;
                }
                return true;
              }
            },
            deleteLastChar: {
              key: 46,
              suffix: /^$/,
              handler: range => {
                if (range.length == 0) {
                  const delta = this.editor.getLength() > 1 ? this.editor.getContents() : false;
                  this.$emit('keyDeleteLastChar', delta);
                  return false;
                } else {
                  return true;
                }
              }
            },
            //  Hijack Undo
            undo: {
              key: 90,
              ctrlKey: true,
              shiftKey: false,
              handler: () => {
                console.log('undo');
                if (this.hijackUndo) {
                  this.$emit('undo');
                  return false;
                } else {
                  return true;
                }
              }
            },
            redo: {
              key: 90,
              shiftKey: true,
              ctrlKey: true,
              handler: () => {
                if (this.hijackUndo) {
                  this.$emit('redo');
                  return false;
                } else {
                  return true;
                }
              }
            },
            //  Hijack copy and paste
            copy: {
              key: 67,
              ctrlKey: true,
              handler: () => {
                console.log('copy');
                if (this.hijackCopy) {
                  console.log('copy');
                  this.$emit('copy');
                  return false;
                } else {
                  console.log('false copy');
                  return true;
                }
              }
            },
            //  Hijack copy and paste
            paste: {
              key: 86,
              ctrlKey: true,
              handler: () => {
                if (this.hijackPaste) {
                  console.log('paste');
                  this.$emit('paste');
                  return false;
                } else {
                  console.log('false paste');
                  return true;
                }
              }
            },
            //  Handle markdown shortcodes
            // # to H1
            markdownHeader: {
              key: 32, // space
              offset: 1,
              shiftKey: null,
              prefix: /^#$/,
              handler: (range, context) => {
                if (!this.allowMarkdown) {
                  return true;
                }
                console.log('h1');
                console.log(range);
                console.log(context);
                this.editor.formatLine(range.index, 1, 'header', '1');
                // this.$emit('setType', 'question');
                this.editor.deleteText(range.index - 1, 1);
              }
            },
            'header enter': {
              // overwrite quills default behavior here
              key: 'Enter',
              handler: (range, context) => {
                console.log('header enter');
                this.$emit('keyEnter', false);
              }
            },
            markdownHeader2: {
              key: 32, // space
              offset: 2,
              shiftKey: null,
              prefix: /^##$/,
              handler: (range, context) => {
                if (!this.allowMarkdown) {
                  return true;
                }
                // this.$emit('setType', 'thought');
                this.editor.formatLine(range.index, 1, 'header', 'h2');
                this.editor.deleteText(range.index - 2, 2);
              }
            }
          }
        }
      },
      readOnly: this.disabled ? this.disabled : false
    });

    const startingDelta = this.editor.clipboard.convert(this.value.html);
    this.editor.setContents(startingDelta, 'silent');
    this.lastUpdated = this.value.updatedOn ? this.value.updatedOn.toDate() : new Date();
    this.previousVal = this.value.html;
    this.editor.on('text-change', (delta, oldDelta, source) => {
      if (source != 'silent') {
        //  TODO: maybe if source is user and debounce on we debounce this?
        this.update();
      }
    });

    this.editor.on('selection-change', (range, oldRange, source) => {
      if (range === null && oldRange !== null) {
        console.log('blur selection change');
        this.blur();
      } else {
        if (range.length == 0) {
          console.log('User cursor is on', range.index);
        }
        if (!oldRange && !this.disabled) {
          console.log('focus');
          this.$emit('focus');
        }
      }
    });
    this.updatePrevious = debounce(this.updatePreviousMethod.bind(this), 1000);
    this.$emit('editorReady');
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  methods: {
    update() {
      const text =
        this.editor && this.editor.getText()
          ? this.emitText
            ? this.editor.getText()
            : this.editor.root.innerHTML
          : '';
      this.$emit('input', text);
      this.updatePrevious(text);
    },
    updatePreviousMethod(val) {
      //  Update the previous value after a wait of 1s, simulates updates to the db
      console.log('I only get fired once every two seconds, max!');
      console.log('this', this);
      this.previousVal = val;
    },
    setContents(delta) {
      this.editor.setContents(delta);
    },
    getContents() {
      return this.editor.getContents();
    },
    updateContents(delta) {
      //const currentDelta = this.editor.getContents();
      const oldDelta = new Delta().retain(this.editor.getLength() - 1).delete(1);
      const newDelta = delta ? oldDelta.concat(delta) : oldDelta;
      this.editor.updateContents(newDelta);
    },
    focus(selectAll = false) {
      //this.editor.focus();
      const length = this.editor.getLength();
      if (length > 1 && selectAll) {
        // highlight the text
        this.editor.setSelection(0, length);
      } else {
        // just focus the input
        this.editor.focus();
      }
    },
    setCaret({ prevLeft, direction = 'down' }) {
      const newIndex = this.findIndex(prevLeft, direction);
      this.editor.setSelection(newIndex);
    },
    blur() {
      this.$emit('blur');
    },
    formatLine(format) {
      //  format is p, 1, or 2
      console.log(format);
      if (format === 'p') {
        console.log('remove format');
        this.editor.format('header', false, 'user');
      } else {
        console.log('formatLine');
        this.editor.format('header', format, 'user');
      }
    },
    getFormat() {
      return this.editor.getFormat();
    },
    findIndex(left, direction = 'down') {
      let dist;
      let oldDist;
      let length = this.editor.getLength();
      let i = 0;
      if (direction == 'down') {
        while (i < length) {
          let bounds = this.editor.getBounds(i);
          dist = Math.abs(bounds.left - left);
          if (!isNaN(oldDist) && oldDist < dist) {
            i--;
            break;
          } else {
            oldDist = dist;
            i++;
          }
        }
      } else {
        i = length - 1;
        while (i >= 0) {
          let bounds = this.editor.getBounds(i);
          dist = Math.abs(bounds.left - left);
          if (!isNaN(oldDist) && oldDist < dist) {
            i++;
            break;
          } else {
            oldDist = dist;
            i--;
          }
        }
      }

      return i;
    }
  }
};
</script>

<style>

.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.4);
  content: attr(data-placeholder);
  font-style: none;
  pointer-events: none;
  position: absolute;
}

.ql-disabled .ql-editor {
  pointer-events: none;
  user-select: none;
}

[contenteditable='true']:empty::before {
  content: attr(placeholder);
  opacity: 0.2;
}

.ql-editor {
  min-height: auto;
  font-size: inherit;
  border: none;
  outline: none;
  padding: 0px;
}

.ql-container.ql-snow {
  border: 0px;
  background-color: transparent;
}

.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}

.editing .text-line {
  cursor: text;
}

.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}
.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}
.ql-editor ul > li::before {
  content: '\2022';
}
.ql-editor ul[data-checked=true],
.ql-editor ul[data-checked=false] {
  pointer-events: none;
}
.ql-editor ul[data-checked=true] > li *,
.ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
.ql-editor ul[data-checked=true] > li::before,
.ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.ql-editor ul[data-checked=true] > li::before {
  content: '\2611';
}
.ql-editor ul[data-checked=false] > li::before {
  content: '\2610';
}
.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor ol li:before {
  content: counter(list-0, decimal) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) '. ';
}
.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) '. ';
}
.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) '. ';
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
</style>
